import { render, staticRenderFns } from "./focus.vue?vue&type=template&id=4e2aab4f&scoped=true"
import script from "./focus.vue?vue&type=script&lang=js"
export * from "./focus.vue?vue&type=script&lang=js"
import style0 from "./focus.vue?vue&type=style&index=0&id=4e2aab4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2aab4f",
  null
  
)

export default component.exports